import { render, staticRenderFns } from "./xwzz_donate_detail.vue?vue&type=template&id=83145eca&scoped=true"
import script from "./xwzz_donate_detail.vue?vue&type=script&lang=js"
export * from "./xwzz_donate_detail.vue?vue&type=script&lang=js"
import style0 from "./xwzz_donate_detail.vue?vue&type=style&index=0&id=83145eca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83145eca",
  null
  
)

export default component.exports